<style scoped>
    .short {
        max-height: 225px;
        overflow: hidden;
        text-overflow: ellipsis;
        mask-image: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 1)), to(rgba(0, 0, 0, 0)));
    }
</style>

<template>
    <a-tooltip
        ref="slot_content"
        :overlay-class-name="getOverlayClassName"
        :placement="placement"
        :trigger="['hover', 'click']"
        @visibleChange="onVisibleChange"
    >
        <template #title>
            <div :class="{short: !isFullSize}">
                <slot />
            </div>
            <div
                v-if="!isFullSize"
                class="text-center"
            >
                <a @click="showFullText">
                    <a-icon style="opacity: 0.5" type="down-circle" />
                </a>
            </div>
        </template>
        <slot name="element">
            <a-icon
                style="font-size: 15px; vertical-align: 1px;"
                type="question-circle"
            />
        </slot>
    </a-tooltip>
</template>

<script>
    export default {
        name: 'v-tooltip',
        props: {
            large: {
                default: false,
                type: Boolean,
            },
            placement: {
                default: 'right',
                type: String,
            },
        },
        data() {
            return {
                isFullSize: true,
                titleSlotLength: null,
                titleSlotLengthThreshold: 625,
            };
        },
        computed: {
            getOverlayClassName() {
                return this.large ? 'v-tooltip-large' : 'v-tooltip';
            },
        },
        methods: {
            isTextOverThreshold() {
                return this.titleSlotLength > this.titleSlotLengthThreshold;
            },
            onVisibleChange(visible) {
                if (!visible && this.isTextOverThreshold()) {
                    this.isFullSize = false;
                }
            },
            showFullText() {
                this.isFullSize = true;
            },
        },
        mounted() {
            try {
                this.titleSlotLength = this.$refs.slot_content.$slots.title[0].children[0].text.length;
                if (this.isTextOverThreshold()) {
                    this.isFullSize = false;
                }
            } catch (err) {
                // do nothing
            }
        },
    };
</script>
